module.exports = __webpack_public_path__ + "img/send.b513173c.svg";